const warn = process.env.NODE_ENV !== "production" && console ? console.warn.bind(console) : function () {};

export { warn as default };
